import React from 'react';
import ReactDOM from 'react-dom/client';
import { RSVP } from './RSVP';
import reportWebVitals from './reportWebVitals';

const rsvp = ReactDOM.createRoot(document.getElementById('rsvp-react'));
rsvp.render(
    <RSVP />
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
